module.exports = __webpack_public_path__ + "img/JNJ.242f219a.png";